const config = {
  emailJsPublicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  emailJsTemplateKey: process.env.REACT_APP_EMAILJS_TEMPLATE_KEY,
  emailJsServiceKey: process.env.REACT_APP_EMAILJS_SERVICE_KEY,
}

export default config
